import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Navigation from './components/Navigation'
import ScrollToTop from './components/ScrollToTop'
import Home from './pages/Home'
import Features from './pages/Features'
import Pricing from './pages/Pricing'
import Build from './pages/Build'
import Industries from './pages/Industries'
import RealEstate from './pages/RealEstate'
import Automobile from './pages/Automobile'
import Education from './pages/Education'
import Hospitality from './pages/Hospitality'
import Healthcare from './pages/Healthcare'
import Contact from './pages/Contact'
import InquiryForm from './pages/InquiryForm'
import TermsOfService from './pages/TermsOfService'
import PrivacyPolicy from './pages/PrivacyPolicy'
import './App.css'

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger)

function App() {
  useEffect(() => {
    // Initialize GSAP ScrollTrigger
    ScrollTrigger.refresh()
    
    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill())
    }
  }, [])

  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/features" element={<Features />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/build" element={<Build />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/industries/real-estate" element={<RealEstate />} />
          <Route path="/industries/automobile" element={<Automobile />} />
          <Route path="/industries/education" element={<Education />} />
          <Route path="/industries/hospitality" element={<Hospitality />} />
          <Route path="/industries/healthcare" element={<Healthcare />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/inquiry" element={<InquiryForm />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
      </div>
    </Router>
  )
}

export default App